<div class="source-container">
  <div class="sub-item-title">Source</div>

  <div class="source">

    <div *ngIf="isNodesExists(item.source)">
      <div class="sub-title">Nodes:</div>
      <div class="sub-item">
                <span *ngFor="let node of item.source.nodes; let last=last;">
                    <span>&nbsp;{{node.name}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
      </div>
    </div>

    <div *ngIf="isPConExists(item.source)">
      <div class="sub-title">Peer Connections:</div>
      <div class="sub-item">
                <span *ngFor="let pCon of item.source.pcons; let last=last;">
                    <span>&nbsp;{{pCon.name}}&nbsp;&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
      </div>
    </div>

    <div *ngIf="isReroutePConExists(item.source)">
      <div class="sub-title">Reroute Peer Connections:</div>
      <div class="sub-item">
                <span *ngFor="let pCon of item.source.reroutePcons; let last=last;">
                    <span>&nbsp;{{pCon.name}}&nbsp;&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
      </div>
    </div>

    <div *ngIf="isResourceGroupExist(item.source)">
      <div class="sub-title">Resource Groups:</div>
      <div class="sub-item">
                <span *ngFor="let group of item.source.resourceGroups; let last=last;">
                    <span>&nbsp;{{group.name}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
      </div>
    </div>

    <div *ngIf="isUserGroupsExists(item.source)">
      <div class="sub-title">User Groups:</div>
      <div class="sub-item">
                <span *ngFor="let userGroup of item.source.userGroups; let last=last;">
                    <span>&nbsp;{{userGroup.name}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
      </div>
    </div>

    <div *ngIf="isCustomersExists(item.source)">
        <div class="sub-title">Customers:</div>
        <div class="sub-item">
              <span *ngFor="let customer of item.source.sourceCustomers; let last=last;">
                  <span>&nbsp;{{customer.name}}&nbsp;<span *ngIf="!last">&bull;</span></span>
              </span>
        </div>
    </div>

    <div *ngIf="useAllCustomers(item.source)">
       <div class="sub-title">Customers:</div>
       <div class="sub-item">
            <span>Use All Customers</span>
       </div>
    </div>

    <div *ngIf="isRRAttributesExists(item.source, 'general')">
      <div *ngIf="isRRAttributesExists(item.source, 'host')">
        <div class="sub-title">Hosts:</div>
        <div class="sub-item">
                    <span *ngFor="let host of item.source.rrAttrs.attributes.host; let last=last;">
                        <span>&nbsp;{{host}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                    </span>
        </div>
      </div>

      <div *ngIf="isRRAttributesExists(item.source, 'prefix')">
        <div class="sub-title">Prefixes:</div>
        <div class="sub-item">
                    <span *ngFor="let prefix of item.source.rrAttrs.attributes.prefix; let last=last;">
                        <span>&nbsp;{{prefix}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                    </span>
        </div>
      </div>

      <div *ngIf="isRRAttributesExists(item.source, 'prefixGroups')">
        <div class="sub-title">Prefix Groups:</div>
        <div class="sub-item">
                    <span *ngFor="let prefixGroup of item.source.rrAttrs.attributeGroups; let last=last;">
                        <span>&nbsp;{{prefixGroup.name}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                    </span>
        </div>
      </div>
    </div>
  </div>

</div>
